<template>
  <div id="contenedor-licitacion-visita-obra-asistio">
    <v-form v-model="formularioValido" ref="asistioVisitaObra">
      <v-switch v-model="asistio" @change="quitarAgregar" inset> </v-switch>
    </v-form>
  </div>
</template>

<script>
import AGREGAR_LICITACION_VISITA_OBRA from '@/graphql/mutations/administracion/licitaciones/visitaobra/agregarLicitacionVisitaObra.gql';
import REMOVER_LICITACION_VISITA_OBRA from '@/graphql/mutations/administracion/licitaciones/visitaobra/removerLicitacionVisitaObra.gql';
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';

export default {
  name: 'LicitacionVisitaObraAsistio',
  props: {
    participanteVisitaObra: Object,
  },
  data() {
    return {
      formularioValido: false,
      asistio: null,
    };
  },
  methods: {
    quitarAgregar() {
      if (this.asistio === false) {
        this.eliminarLicitacionVisitaObra();
      } else {
        this.agregarLicitacionVisitaObra();
      }
    },
    setAsistio() {
      if (!this.participanteVisitaObra.visitaObra) return;
      this.asistio = this.participanteVisitaObra.visitaObra.asistio;
    },

    async agregarLicitacionVisitaObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: AGREGAR_LICITACION_VISITA_OBRA,
          variables: {
            idLicitacion: this.participanteVisitaObra.idLicitacion,
            idParticipante: this.participanteVisitaObra.id,
            asistio: this.asistio,
          },
          update: (store, { data: { agregarLicitacionVisitaObra } }) => {
            const data = store.readQuery({
              query: LICITACION_PARTICIPANTES,
              variables: {
                idLicitacion: this.participanteVisitaObra.idLicitacion,
              },
            });
            const participante = data.licitacionParticipantes.find(
              (participanteVisita) => participanteVisita.id === this.participanteVisitaObra.id,
            );
            participante.visitaObra = agregarLicitacionVisitaObra;
            store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
    async eliminarLicitacionVisitaObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_LICITACION_VISITA_OBRA,
          variables: {
            idParticipante: this.participanteVisitaObra.id,
          },
          update: (store) => {
            const data = store.readQuery({
              query: LICITACION_PARTICIPANTES,
              variables: {
                idLicitacion: this.participanteVisitaObra.idLicitacion,
              },
            });
            const participante = data.licitacionParticipantes.find(
              (participanteVisita) => participanteVisita.id === this.participanteVisitaObra.id,
            );
            participante.visitaObra = null;
            store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
  mounted() {
    this.setAsistio();
  },
};
</script>

<style>
</style>
